import script from "./CusSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CusSelect.vue?vue&type=script&setup=true&lang=js"

import "./CusSelect.vue?vue&type=style&index=0&id=8f2eaa2a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f2eaa2a"]])

export default __exports__